import { isRecommendedPackage } from '../../../../utils/packagesUtils';
import { BQ_CLICKED_PACKAGES_TAB } from '../../../../utils/bigQueryEvents';
import { TAB_NAMES } from '../config';

export const calcDefaultCheckedId = (packageList) => {
    let defaultCheckedId = 1;

    packageList.forEach((packageData) => {
        if (isRecommendedPackage(packageData)) {
            defaultCheckedId = packageData.id;
        }
    });

    return defaultCheckedId;
};

export const reportTabClickEvent = (biEvents, tabId) => {
    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_PACKAGES_TAB,
        params: {
            page: {
                element: {
                    name: TAB_NAMES[tabId - 1],
                    position: tabId
                }
            }
        }
    });
};
